<template>
  <Modal
    v-model:show="active"
    class="modal-password enable-success"
  >
    <template v-slot:header>
      <h5 class="modal-title">
        {{ $t('profile.modalPasswordTwoFactor.title') }}
      </h5>
    </template>

    <div class="!tw-text-center">
      <h1 class="!tw-text-center mt-32">
        <img
          :src="okImg"
          alt=""
        >
      </h1>
      <p class="mb-32">
        {{ $t('profile.modalPasswordTwoFactor.securityCode') }}
      </p>
    </div>

    <template v-slot:footer>
      <div class="!tw-text-center">
        <button
          class="btn btn-primary btn-md"
          @click="active = false"
        >
          {{ $t('profile.modalPasswordTwoFactor.btn') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import okImg from '@/assets/theme/icon/ok.svg';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    okImg: () => okImg,
  },
  methods: {
    open() {
      this.active = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.enable-success {
  .btn-primary {
    min-width: 196px !important;
  }
}
</style>
